import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { SectionLabel } from '../ui/SectionLabel';
export function UrgencyBanner() {
  return <section aria-labelledby="urgencia-title" className="w-full bg-pitch" data-id="element-211" data-mp="238z9f25ibtjb">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center md:py-20" data-id="element-212" data-mp="2hx3rq50ne31k">
        <SectionLabel tone="gold" data-id="element-213" data-mp="2d4k4shg2lvk3">Oferta especial por tiempo limitado</SectionLabel>
        <h2 id="urgencia-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-214" data-mp="2qvxllnmlgfbf">
          El precio de lanzamiento termina pronto
        </h2>
        <p className="mt-4 max-w-xl text-base text-body" data-id="element-215" data-mp="30tv6q295pvzt">
          Después, el precio aumentará y el paquete dejará de estar disponible a este valor.
        </p>
        <div className="mt-8" data-id="element-216" data-mp="16glvo60yq2fg">
          <CtaButton size="xl" data-id="element-217" data-mp="16hwxw1erf24g">Aprovechar oferta de lanzamiento</CtaButton>
        </div>
      </div>
    </section>;
}